import { apiConfig } from "../authConfig";

export const uploadFile = async (
    file: File,
    userId: number,
    fileUpload: { [key: string]: any }, // Object matching the FileUpload model
    token: string | null
  ): Promise<any> => {
    const formData = new FormData();
  
    formData.append("file", file);
  
    formData.append("userId", userId.toString());
  
    Object.entries(fileUpload).forEach(([key, value]) => {
      formData.append(key, value);
    });
    
    const url = `${(window as any)?.REACT_APP_API_URL}FileUpload/FileUpload`;
  
    const headers = new Headers({
      Authorization: `Bearer ${token}`,
    });
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers,
        body: formData,
      });
  
      const contentType = response.headers.get("Content-Type");
    if (contentType && contentType.includes("application/json")) {
      return await response.json();
    } else {
      const textResponse = await response.text();
      console.warn("Non-JSON response received:", textResponse);
      return { message: textResponse };
    }
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  };
  